import { render, staticRenderFns } from "./PoiModal.vue?vue&type=template&id=62f4540c"
import script from "./PoiModal.vue?vue&type=script&lang=js"
export * from "./PoiModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports